import { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'
import { useSites } from 'store'

const OPERATION_COUNT_DOCUMENTS = gql`
  query countAudinDocuments($sf_ids: [ID]) {
    counts: countAudinDocuments(sf_ids: $sf_ids) {
      counting_step {
        key
        count
      }
      counting_type {
        key
        count
      }
    }
  }
`

const useCount = () => {
  const [{ selected }] = useSites()
  const sfIds = useMemo(() => (selected ? selected.map(({ sf_id }) => sf_id) : []), [selected])
  const { error, loading, data } = useQuery(OPERATION_COUNT_DOCUMENTS, {
    variables: {
      sf_ids: sfIds
    }
  })
  const count = useMemo(() => {
    if (!data) {
      return {}
    }
    const { counting_type, counting_step } = data.counts
    return {
      type: counting_type.reduce((acc, { key, count }) => ({ ...acc, [key]: count }), {}),
      step: counting_step.reduce((acc, { key, count }) => ({ ...acc, [key]: count }), {})
    }
  }, [data])
  return {
    loading,
    error,
    ...count
  }
}

export default useCount;